import React from 'react';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import Button from 'housecall-ui/dist/library/Buttons/Button';

import { PayWallDuration } from 'components/PayWall/Redux/Reducer.type';

import CurrencyDisplay from '../Common/Currency/CurrencyDisplay';
import IncrementDecrement from '../Common/IncrementDecrement';

import { PriceDisplay } from './PayWallPlanSummary';

const useStyles = makeStyles({
  alignRightGrid: {
    textAlign: 'right',
  },
});

type Props = {
  onChangeAdditionalUsers: (value: number) => unknown;
  additionalUsers: number;
  additionalUsersRate: number;
  minimumAdditionalUsers?: number;
  existingUsersCount: number | null;
  numberOfFreeSeatsFromCurrentPlan: number;
  isDowngradingPlan: boolean;
};

export default function AddTeamMembers(props: Props) {
  const {
    additionalUsersRate,
    additionalUsers,
    minimumAdditionalUsers,
    onChangeAdditionalUsers,
    existingUsersCount,
    numberOfFreeSeatsFromCurrentPlan,
    isDowngradingPlan,
  } = props;

  const availableSeats = `${numberOfFreeSeatsFromCurrentPlan} employee ${
    numberOfFreeSeatsFromCurrentPlan > 1 ? 'logins' : 'login'
  }. `;
  const existingUsers = `${existingUsersCount} employee ${
    existingUsersCount && existingUsersCount > 1 ? 'logins' : 'login'
  }. `;
  const shouldDisplayDowngradeError =
    isDowngradingPlan && additionalUsers > 0 && minimumAdditionalUsers === additionalUsers;

  const classes = useStyles();

  return (
    <>
      <Grid container alignItems="center" justify="space-between" data-testid="add-team-members">
        {shouldDisplayDowngradeError && (
          <Grid item container xs={12}>
            <Alert severity="warning" data-testid="add-team-members-notice">
              <Grid item xs={12}>
                <Typography variant="body2" align="justify">
                  The selected plan includes <strong>{availableSeats}</strong>
                  Your current plan has <strong>{existingUsers}</strong>
                  You will be charged for these additional logins unless you remove employees from your account.
                </Typography>
              </Grid>
              <Grid xs={12} item className={classes.alignRightGrid}>
                <Button href="/pro/account/employees">Manage employees</Button>
              </Grid>
            </Alert>
            <Box mb={3} />
          </Grid>
        )}
        <Grid item xs={5}>
          <Typography>Additional logins</Typography>
        </Grid>
        <Grid item xs={3} className={classes.alignRightGrid} data-testid="additional-login-price">
          <PriceDisplay
            price={<CurrencyDisplay amountInCents={additionalUsersRate} decimalScale={0} />}
            duration={PayWallDuration.Monthly}
          />
        </Grid>
        <Grid item xs={4}>
          <IncrementDecrement
            initialValue={additionalUsers}
            minimumValue={minimumAdditionalUsers ?? 0}
            onChange={(newValue: number) => {
              onChangeAdditionalUsers(newValue);
            }}
          />
        </Grid>
      </Grid>
      <Box my={2}>
        <Divider />
      </Box>
    </>
  );
}
